import { render, staticRenderFns } from "./TeamRegistrationDialog.vue?vue&type=template&id=0b3873dd&scoped=true"
import script from "./TeamRegistrationDialog.vue?vue&type=script&lang=js"
export * from "./TeamRegistrationDialog.vue?vue&type=script&lang=js"
import style0 from "./TeamRegistrationDialog.vue?vue&type=style&index=0&id=0b3873dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3873dd",
  null
  
)

export default component.exports